export async function readNDJSONStream<T>(
    body: ReadableStream<Uint8Array>,
    onMessage: (message: T) => void
): Promise<void> {
    const reader = body.getReader()
    const decoder = new TextDecoder()
    let buffer = ""

    const processLine = (line: string): void => {
        if (line.trim().length === 0) {
            return
        }

        onMessage(JSON.parse(line) as T)
    }

    try {
        while (true) {
            const { value, done } = await reader.read()

            buffer += decoder.decode(value, { stream: !done })
            const lines = buffer.split("\n")
            buffer = lines.pop() ?? ""

            for (const line of lines) {
                processLine(line)
            }

            if (done) {
                break
            }
        }
    } catch (error) {
        await reader.cancel()
        throw error
    }

    processLine(buffer)
}
